'use strict';

import {GPStructure} from "./gp-structure.js";
import {GP3DItemRenderer} from "./gp-3ditemrenderer.js";
import {GPContextItems} from "./gp-context-items.js";
import {lightDirection} from "./gp";
import { get } from 'svelte/store';

export class GPStructure3D extends GPStructure {
    constructor (id, typeId, x, y, scale, horizontalFlip, adjustment, rotation) {
        super(id, typeId, x, y, scale, horizontalFlip, adjustment);
        this.rotation = rotation ? rotation : (this.data.initrot ? parseFloat(this.data.initrot) : 0);
        this.supportsRotate = true;
        this.supportsThumb = false;
        this.supportsFlip = false;
        this.visualHeightFactor = 1;
    }

    createDisplayObject (season, thumb) {
        var that = this;

        return new Promise(function(resolve, reject) {
            let lightdir = get(lightDirection);
            GP3DItemRenderer.renderObjectToCanvas(that.getModelPath(), that.rotation, that.data.height, that.data.outline, lightdir).then((res) => {
                let imageObj = res.img;
                that.visualHeightFactor = res.visualHeightFactor;
                that.xShift = res.xShift;

                that.imageWidth = imageObj.width;
                that.imageHeight = imageObj.height;

                let result = new Konva.Image({
                    draggable: !that.fixedObject,
                    image: imageObj,
                    id: String(that.id),
                    shadowColor: 'black',
                    shadowBlur: 5,
                    shadowEnabled: that.fixedObject
                });

                resolve(result);

            })
        });
    }

    async redraw () {
        return await GPContextItems.addItemInstanceToView(this);
    }

    itemImageScale (projy) {
        let scale = super.itemImageScale(projy);
        return scale * this.visualHeightFactor;
    }

    getModelPath () {
        return GPSettings.structuresAddr(this.data, false, "b") +'3d/'+this.data.image+'.glb';
    }

    toJSON() {
        let res = super.toJSON();
        res.r = this.rotation;
        return res;
    }
}